const defaultState = {};

export const configReducer = (state = defaultState, action) => {
  let system = {};

  switch (action.type) {
    case "SAVE_CONFIG":
      system = action.payload;

      localStorage.setItem("config", JSON.stringify(system));

      return system;

    case "REMOVE_CONFIG":
      return defaultState;

    default:
      return state;
  }
};
